import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SendNotification from "../../components/Notification/SendNotification";


const EditNotification = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>
        <Breadcrumb  id="title" title2="Notification" link2="/notification" title="Edit Notification" />
        <SendNotification />

      </MasterLayout>

    </>
  );
};

export default EditNotification; 
